
import React from 'react';
import { 
  LayoutDashboard, 
  Warehouse, 
  ShoppingCart, 
  Users2, 
  Menu 
} from 'lucide-react';
import { motion } from 'motion/react';
import { NavLink } from 'react-router-dom';

interface BottomNavProps {
  activeTab: string;
  onMenuClick: () => void;
  currentUser: any;
}

export const BottomNav: React.FC<BottomNavProps> = ({ activeTab, onMenuClick, currentUser }) => {
  const hapticFeedback = () => {
    if (window.navigator.vibrate) {
      window.navigator.vibrate(10);
    }
  };

  const navItems = [
    { id: 'dashboard', label: 'الرئيسية', icon: LayoutDashboard, permissionKey: 'viewDashboard' },
    { id: 'warehouses', label: 'المخازن', icon: Warehouse, permissionKey: 'viewWarehousesDashboard' },
    { id: 'orders', label: 'الطلبات', icon: ShoppingCart, permissionKey: 'viewOrders' },
    { id: 'employees', label: 'الموظفين', icon: Users2, permissionKey: 'viewEmployees' },
  ];

  const visibleItems = navItems.filter(item => {
    if (item.permissionKey && currentUser && !currentUser.permissions[item.permissionKey]) return false;
    return true;
  });

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-xl border-t border-slate-100 px-6 py-3 pb-8 lg:hidden z-[40] flex items-center justify-between shadow-[0_-10px_30px_-15px_rgba(0,0,0,0.1)]">
      {visibleItems.map((item) => {
        const Icon = item.icon;

        return (
          <NavLink
            key={item.id}
            to={`/${item.id}`}
            onClick={hapticFeedback}
            className={({ isActive }) => `flex flex-col items-center gap-1.5 relative group ${isActive ? 'text-indigo-600' : 'text-slate-400'}`}
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <motion.div
                    layoutId="nav-active"
                    className="absolute -top-3 w-8 h-1 bg-indigo-600 rounded-full"
                    transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                  />
                )}
                <div className={`p-1 transition-all duration-300 ${isActive ? 'scale-110' : ''}`}>
                  <Icon size={22} strokeWidth={isActive ? 2.5 : 2} />
                </div>
                <span className="text-[10px] font-black tracking-tight transition-colors">
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        );
      })}

      <button
        onClick={() => {
          hapticFeedback();
          onMenuClick();
        }}
        className="flex flex-col items-center gap-1.5 text-slate-400 group"
      >
        <div className="p-1 group-active:scale-90 transition-transform">
          <Menu size={22} strokeWidth={2} />
        </div>
        <span className="text-[10px] font-black tracking-tight">المزيد</span>
      </button>
    </nav>
  );
};
